import React, { Component } from 'react';
import Img from '../../../../../components/Img/Img';
import Panel from '../../../../../components/outline/Panel';
import Anchor from '../../../../../components/link/Anchor';
import Button from '../../../../../components/Button';
import TableTransfer from '../../../../../components/input/TableTransfer';
import ExcelUploadForm from '../../../../../components/form/ExcelUploadForm';
import { TAG_UPLOAD_TEMPLATE_XLSX_URL } from '../../../../../constants/service/common/staticFileUrlConstants';
import { comparePrePropsAndNextProps } from '../../../../../lib/common';
import tagTabMainFollowSelectedInfo from '../../../../../static/images/tag/tagTabMain/tag-tab-main-follow-selected-info.png';
import { columns } from './columns';
import {
  TAG_TAB_MAIN_MANAGEMENT_PAGE_PANEL_NAME,
  TAG_TAB_MAIN_SECTION_TYPE,
} from '../../../../../constants/service/app/tagConstants';
import './TagManagementTabMainFollowSelectedList.scss';

class TagManagementTabMainFollowSelectedList extends Component {
  /**
   *  Component 의 변경되는 props 와 state 가 있을 경우에만,
   *  render 메소드를 호출할 수 있도록 함
   */
  shouldComponentUpdate = (nextProps, nextState) => {
    return comparePrePropsAndNextProps([
      [nextProps, this.props],
      [nextState, this.state],
    ]);
  };

  render() {
    const {
      tagFollowSelectedList,
      selectTagTabMainContentsList,
      onDragEndSelectTagTabMainContentsList,
      getTagTabMainContentsList,
      getRelatedTagList,
      getTagTabMainAllListExcelDownload,
      getTagTabMainSelectedListExcelDownload,
      setTagTabMainExcelUpload,
    } = this.props;
    const { itemList, selectedItemList } = tagFollowSelectedList;

    return (
      <Panel
        name={TAG_TAB_MAIN_MANAGEMENT_PAGE_PANEL_NAME.TAG_FOLLOW_SELECTED_LIST}
        className="tag-management-tab-main-follow-selected-list"
      >
        <div className="panel-header">
          <div className="title">미리 선정된 팔로우한 태그 리스트</div>
        </div>

        <div className="panel-body">
          <div className="tag-main-tab-info">
            <Img className="tag-main-tab-info-img" src={tagTabMainFollowSelectedInfo} />

            <div className="help-text">
              <div>* 유저마다 팔로우 태그 개수가 4개 이하일 경우에만 미리 선정된 태그가 노출됩니다.</div>
              <div>* 미리 선정된 팔로우한 태그 리스트는 최소 10개에서 최대 30개까지 설정할 수 있습니다.</div>
            </div>
          </div>

          <TableTransfer
            dataSource={itemList.list}
            operations={['연결', '해제']}
            leftTitle={'선택할 태그 리스트'}
            rightTitle={'트렌드 키워드 리스트'}
            leftTableProps={{
              columns: (utils) =>
                columns({
                  ...utils,
                  getRelatedTagList,
                  isFilter: true,
                }),
              headInfo: (
                <div className="follow-selected-tag-head right">
                  <Button
                    isRadius
                    color="light"
                    text="엑셀 다운로드"
                    onClick={() =>
                      getTagTabMainAllListExcelDownload(TAG_TAB_MAIN_SECTION_TYPE.TAG_FOLLOW_SELECTED_LIST)
                    }
                  />
                </div>
              ),
              rowClassName: (record) => (record.uncheckable ? 'uncheckable' : null),
              getList: (option) =>
                getTagTabMainContentsList({
                  ...option,
                  tagTabMainSectionType: TAG_TAB_MAIN_SECTION_TYPE.TAG_FOLLOW_SELECTED_LIST,
                }),
              pagination: itemList.pagination,
              sortOption: itemList.sortOption,
              filterOption: itemList.filterOption,
            }}
            rightTableProps={{
              columns: (utils) =>
                columns({
                  ...utils,
                  getRelatedTagList,
                }),
              headInfo: (
                <div className="follow-selected-tag-head">
                  <div className="selected-follow-selected-tag-item-count">
                    선택된 아이템 개수 <span>{selectedItemList.list.length}</span>
                  </div>

                  <div className="excel-button-list">
                    <Anchor
                      text="태그 업로드 템플릿"
                      isUnderLine
                      color="primary"
                      href={TAG_UPLOAD_TEMPLATE_XLSX_URL}
                      target="_blank"
                    />

                    <ExcelUploadForm
                      onChange={(file) =>
                        setTagTabMainExcelUpload(file, TAG_TAB_MAIN_SECTION_TYPE.TAG_FOLLOW_SELECTED_LIST)
                      }
                      btnText="태그 엑셀 업로드"
                    />

                    <Button
                      isRadius
                      color="light"
                      text="엑셀 다운로드"
                      onClick={() =>
                        getTagTabMainSelectedListExcelDownload(TAG_TAB_MAIN_SECTION_TYPE.TAG_FOLLOW_SELECTED_LIST)
                      }
                    />
                  </div>
                </div>
              ),
              list: selectedItemList.list,
              canDrag: true,
              onDragEnd: (newList) =>
                onDragEndSelectTagTabMainContentsList(newList.list, TAG_TAB_MAIN_SECTION_TYPE.TAG_FOLLOW_SELECTED_LIST),
            }}
            onChange={(action, moveIdList) =>
              selectTagTabMainContentsList(action, moveIdList, TAG_TAB_MAIN_SECTION_TYPE.TAG_FOLLOW_SELECTED_LIST)
            }
          />
        </div>
      </Panel>
    );
  }
}

export default TagManagementTabMainFollowSelectedList;
